import React, { useState, useEffect } from 'react'
import './navbar.css'
import { AiOutlineHome } from 'react-icons/ai'
import { BiBook } from 'react-icons/bi'
import { RiServiceLine } from 'react-icons/ri'
import { BiMessageSquareDetail } from 'react-icons/bi'
import { BsCode } from 'react-icons/bs'
import { useLanguage } from '../../context/LanguageContext'
import useScrollspy from '../../hooks/useScrollspy'

const Navbar = () => {
  const [visible, setVisible] = useState(false)
  const { t } = useLanguage()
  const activeSection = useScrollspy(['Home', 'Skills', 'Projects', 'Services', 'Contact'])

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const links = [
    { href: '#Home',     section: 'Home',     icon: <AiOutlineHome />,         label: t.nav.home },
    { href: '#Skills',   section: 'Skills',   icon: <BsCode />,                label: t.nav.skills },
    { href: '#Projects', section: 'Projects', icon: <BiBook />,                label: t.nav.projects },
    { href: '#Services', section: 'Services', icon: <RiServiceLine />,         label: t.nav.services },
    { href: '#Contact',  section: 'Contact',  icon: <BiMessageSquareDetail />, label: t.nav.connect },
  ]

  return (
    <nav className={visible ? 'nav--visible' : ''}>
      {links.map(({ href, section, icon, label }) => (
        <a
          key={section}
          href={href}
          className={activeSection === section ? 'nav-link active' : 'nav-link'}
        >
          <span className='nav-icon'>{icon}</span>
          <span className='nav-label'>{label}</span>
        </a>
      ))}
    </nav>
  )
}

export default Navbar

